export default "__VITE_ASSET__Bqp9RaJf__"